import { differenceInCalendarMonths } from 'date-fns'
import { type Car, CarStatus } from '../../types'

export function mapCarStatus(status: string): string {
  switch (status) {
    case CarStatus.Active:
      return 'Aktiv'
    case CarStatus.Order:
      return 'I bestilling'
    case CarStatus.Administrated:
      return 'Administrert'
    case CarStatus.Closed:
      return 'Avsluttet'
    default:
      return status
  }
}

export function mapMake(make: string): string {
  let mappedMake = make.toLowerCase()

  switch (mappedMake) {
    case 'vw':
      mappedMake = 'volkswagen'
      break
    case 'mercedes-benz':
      mappedMake = 'mercedesbenz'
      break
    case 'mercedes':
      mappedMake = 'mercedesbenz'
      break
    default:
      break
  }

  return mappedMake
}

export function getReturnDateTitleAndText(car: Car) {
  const { status, actualDeliveryDate, deliveryDate, plannedReturnDate } = car

  const isIncomingCar = status === CarStatus.Order
  if (isIncomingCar) {
    return {
      title: 'Estimert levert',
      text: new Date(deliveryDate).toLocaleDateString('no'),
    }
  }

  const hasPlannedReturnDate = !!plannedReturnDate
  const isClosedCar = status === CarStatus.Closed
  if (isClosedCar || hasPlannedReturnDate) {
    return {
      title: 'Planlagt returnert',
      text: hasPlannedReturnDate ? new Date(plannedReturnDate).toLocaleDateString('no') : 'Ingen dato funnet',
    }
  }

  const hasValidActualDeliveryDate = !!actualDeliveryDate
  if (hasValidActualDeliveryDate) {
    return {
      title: 'Levert',
      text: new Date(actualDeliveryDate).toLocaleDateString('no'),
    }
  }

  return {
    title: 'Planlagt returnert',
    text: plannedReturnDate ? new Date(plannedReturnDate).toLocaleDateString('no') : 'Ingen dato funnet',
  }
}

export function isOutgoingCar(status: CarStatus | string, plannedReturnDate: string): boolean {
  const isActiveOrAdministrated = status === CarStatus.Active || status === CarStatus.Administrated
  if (!isActiveOrAdministrated) return false

  const difference = differenceInCalendarMonths(new Date(plannedReturnDate), new Date())

  return difference <= 6
}
